import React, { useContext } from 'react'
import styled from '@emotion/styled/macro'
import { Link } from 'react-router-dom'
import UserContext, { useUser } from '../../../data/user'
const Container = styled('div')`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
    box-sizing: border-box;
    a {
        font-weight: bold;
        margin-left: 1em;
        transition: 0.5s ease all;
        color: initial;
        opacity: 0.8;
        &:hover {
            text-decoration: underline;
            opacity: 1;
        }
    }
`
const PublicNav = () => {
    const [{ activeUser }] = useUser()
    return (
        <Container>
            {activeUser ? (
                <React.Fragment>
                    <Link to="/my/user">My user</Link>
                    <Link to="/logout">Log out</Link>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Link to="/login">Log In</Link>
                    <Link to="/signup">Sign up</Link>
                </React.Fragment>
            )}
        </Container>
    )
}
export default PublicNav
